import { render, staticRenderFns } from "./notifyInvite.vue?vue&type=template&id=51e09497&"
import script from "./notifyInvite.vue?vue&type=script&lang=js&"
export * from "./notifyInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports